import { CardBody, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { MoreVertical } from "react-feather";
import { WeeklyMonDropdown } from "../../../Constant";
import { useState } from "react";
import { CommonTotalDetailsBodyProp } from "../../../Type/DashboardType";

export const CommonTotalDetailsBody = ({ icon, iconClass, profit, profitColor }: CommonTotalDetailsBodyProp) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <CardBody>
      <div className="d-flex justify-content-between">
        <div>
          <div className="d-flex gap-1 align-items-center">
            <div className={`user-box ${iconClass}`}>
              <i className={`fa fa-${icon}`}> </i>
            </div>
            <span className="f-w-500"><strong className={`font-${profitColor} f-w-600`}>{profit}</strong></span>Last 6 Month
          </div>
        </div>
        <div>
          <Dropdown className="icon-dropdown" isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle className="btn border-0 p-0" color="transparent"><MoreVertical /></DropdownToggle>
            <DropdownMenu end aria-labelledby="userdropdown">
              {WeeklyMonDropdown.map((item, index) => (<DropdownItem key={index}>{item}</DropdownItem>))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </CardBody>
  );
};
